import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserInfo } from '@/stores/UserInfoStore';
import NavBar from '@/components/NavBar';
import { TableData, TableConfig } from '@/components/types';
import { useAlert } from '@/components/AlertContext';
import { AlertTypes } from '@/components/types';
import { useLanguageStore } from '@/stores/LanguageStore';
import useFetchData from "@/stores/FetchData";


const SysAdmin: React.FC = () => {
  const [ dataSource, setDataSource ] =  useState<string>("sysadmin");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [cardLoading, setCardLoading] = useState(false);
  const { showAlert } = useAlert();
  const { roles, refresh } = useUserInfo();
  const { language } = useLanguageStore();
  const { fetchData } = useFetchData();
  const [data, setData] = useState<TableData[]>([]);
  const [config, setConfig] = useState<TableConfig | null>(null);
  const [bodyType, setBodyType] = useState<string>("body");

  useEffect(() => {
    const checkUserRoles = async () => {
      if ( !loading && !roles?.includes("SYS_ADMIN")) {
        const accessDenied = language ? language.error.accessDenied : "Error";
        showAlert( accessDenied , AlertTypes.ERROR, 3000);
        navigate('/home');
      }
    }
    checkUserRoles();
  },[roles, loading, navigate, showAlert, language]);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setDataSource(selectedValue);
    
    const fetchCardData = async () => {
  
      let responseData : any;
      let requestData;
      const token: any = localStorage.getItem("user-auth");
      if (token) {
        try {
            console.log(selectedValue);
            const url = selectedValue ? selectedValue : "sysadmin";
            requestData = { method: "GET", endpoint: "/api/" + url, token: token }
  
            responseData = await fetchData(requestData);
        } catch (error) {           
          showAlert("Endpoint error: " + requestData?.endpoint, AlertTypes.WARNING, 3000);
        } finally {
          if (responseData?.status === 401) {
            const er: any = responseData;
            showAlert(er.title + ": " + er.detail , AlertTypes.ERROR, 3000);              
            return;
          }
  
          if (responseData && dataSource){
            setData(responseData?.data || "no data");
            setConfig(responseData?.config || null );
            setBodyType(responseData?.type || "");
          }
        }
      }
      
    };

    setCardLoading(true);
    fetchCardData();
    setCardLoading(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      await refresh();
      setLoading(false);
    };

    const initialEvent = {
      target: {
        value: 'sysadmin'
      }
    } as React.ChangeEvent<HTMLSelectElement>;

    handleSelectChange(initialEvent);
    
    fetchUserData();
  }, []);
  
  return (
    <div className="app"> 
      <div className="container">
      <div className="row justify-content-start" >        
        <div className="col my-1 min-width-350" >
          <div className='card'>
            <div className='card-header'>
              <select id="selectDataSource" className="form-select" disabled={cardLoading}
          onChange={handleSelectChange} value={dataSource}
          >
              <option value="-" disabled>{language?.text.select}</option>
              <option value="sysadmin">{language?.text.systemAdmin}</option>
              <option value="companies">{language?.navlinks?.companies}</option>
              <option value="users">{language?.navlinks?.users}</option>
              </select>
            </div>
            <div className='card-body'>
              <>{cardLoading && ("... loading...")}</>
              {!cardLoading && dataSource && bodyType === 'tabRows' && (
                <div>
                  <table className="table table-striped table-hover">
                    <tbody>
                      {data.map((item) => (
                        <tr key={item.id}>
                          {Object.values(item).map((field, index) => (
                            index === 0
                            ? null
                            : index < 3
                            ? <td key={index}  className="truncate">{field}</td>  // Age column shown by default
                            : <td key={index} className="hover-column truncate">{field}</td>  // Other columns hidden until hover
                          ))} 
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}  
              {!cardLoading && dataSource && bodyType === 'body' && (
                <div>
                {data[0]?.body}
                </div>
              )}
            </div>
          </div>
        </div>
      </div></div>
      <NavBar /> 
    </div>    
  );
};

export default SysAdmin;